var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
import { isInstanceOf, } from "../utilities/aux";
import { isNumber, isScrewThread, } from "../utilities/wsi4_typeguards";
export function isTappingChangeResult(t) {
    const typeGuardMap = {
        screwThread: isScrewThread,
        coreHoleId: isNumber,
    };
    return isInstanceOf(t, typeGuardMap);
}
let TappingDropDown = class TappingDropDown extends Vue {
    constructor() {
        super(...arguments);
        this.selectedIndex = 0;
        this.selection = [];
    }
    tappingChange(e) {
        return {
            screwThread: e,
            coreHoleId: this.coreHoleId,
        };
    }
    onChange(event) {
        this.selectedIndex = event.target.selectedIndex;
        return this.tappingChange(this.selection[this.selectedIndex]);
    }
    initializeSelection(screwThreads) {
        return [
            {
                name: this.i18n.t("noSelection"),
                coreHoleDiameter: 0,
                minDepth: 0,
                identifier: "0",
                symmetricTolerance: 0,
            },
            ...screwThreads,
        ];
    }
    created() {
        this.selectedIndex = this.defaultIndex;
        this.selection = this.initializeSelection(this.matchingScrewThreads);
    }
};
__decorate([
    Prop({ required: true })
], TappingDropDown.prototype, "matchingScrewThreads", void 0);
__decorate([
    Prop({ required: true })
], TappingDropDown.prototype, "coreHoleId", void 0);
__decorate([
    Prop({ required: true })
], TappingDropDown.prototype, "defaultIndex", void 0);
__decorate([
    Inject()
], TappingDropDown.prototype, "i18n", void 0);
__decorate([
    Inject()
], TappingDropDown.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], TappingDropDown.prototype, "tappingChange", null);
TappingDropDown = __decorate([
    Component({
        components: {
            EditDataElementLabel,
        },
        name: "TappingDropDown",
    })
], TappingDropDown);
export default TappingDropDown;
